import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AuthService } from './login.service';
import { MsAdalAngular6Service } from 'microsoft-adal-angular6';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {

  // office 365
  adalService: AuthService;

  loginForm: FormGroup;

  private loginSubscription: Subscription = null;

  constructor(
    private formBuilder: FormBuilder,
    service: AuthService,
    private adalSvc: MsAdalAngular6Service) {

    this.adalService = service;

    if (this.adalSvc.userInfo === null) {

      console.log(this.adalSvc.userInfo);

      localStorage.removeItem('gbi_auth_user');
      localStorage.removeItem('gbi_expires_at');
      // localStorage.removeItem('gbi_username');

    }
  }

  /**
   * 
   */
  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', [Validators.required, Validators.minLength(5)]],
      remember: [false]
    });

    if (localStorage.getItem('gbi_username')) {
      this.loginForm.setValue({
        email: localStorage.getItem('gbi_username'),
        password: '',
        remember: true
      });
    }
  }

  /**
   * 
   */
  ngOnDestroy(): void {
    if (this.loginSubscription !== null) { this.loginSubscription.unsubscribe(); }
  }

  onSubmit() {
    /* if (this.loginForm.invalid) {
      return;
    }

    const email = this.loginForm.get('email').value;
    const password = this.loginForm.get('password').value;
    const remember = this.loginForm.get('remember').value;

    this.loader.show();

    this.loginSubscription = this.authService.login(email, password)
      .subscribe((result: any) => {
        if (result.is_valid) {
          if (remember) {
            localStorage.setItem('gbi_username', email);
          } else {
            localStorage.removeItem('gbi_username');
          }

          window.location.hash = '';
          this.authService.setSession(result);
          this.loader.hide();
          this.router.navigate(['/titles']);
        } else {
          this.loader.hide();
          this.toastr.error(result.message);
        }
      },
        (error) => {
          this.loader.hide();
          this.toastr.error(`Hubo un problema a intentar obtener los datos de sesión: ${error.message}`);
          console.log('Hubo un problema a intentar obtener los datos de sesión');
          console.log(error.message);
        });
*/
  }

}
